import { countBy } from "lodash";

import { EventPlace, trackEngagement } from "./analytics";

export function cleanUpCannedTags(cannedTags: string): string[] {
  return cannedTags
    .trim()
    .split(",")
    .map(canned => canned.replace(/#/g, "").trim())
    .filter(Boolean);
}

export function isTooManyCannedsTags(cannedTags: string): boolean {
  return cleanUpCannedTags(cannedTags).length > 15;
}

export function isCannedsTagsTooLong(cannedTags: string): boolean {
  return cleanUpCannedTags(cannedTags).some(canned => canned.length > 70);
}

export function validateCannedTags(cannedTags: string): string[] {
  const warnings = [];
  if (isCannedsTagsTooLong(cannedTags)) {
    warnings.push("Shortcut is too long (maximum is 70 characters).");
  }
  if (isTooManyCannedsTags(cannedTags)) {
    warnings.push("Too many shortcuts (maximum is 15).");
  }
  if (!cleanUpCannedTags(cannedTags).length) {
    warnings.push("Enter shortcut.");
  }
  return warnings;
}

export type CannedResponseInputMethod = "keyboard" | "mouse";
export interface ICannedResponseUsage {
  response: string;
  method: CannedResponseInputMethod;
}

export function trackCannedResponseUsage(
  message: string,
  usedCannedResponses: ICannedResponseUsage[],
  eventPlace: EventPlace
): boolean {
  const shouldTrack = usedCannedResponses.length > 0;

  if (shouldTrack) {
    const { keyboard = 0, mouse = 0 } = countBy(usedCannedResponses, cr => cr.method);
    const usedCannedResponse = usedCannedResponses.find(cr => message.includes(cr.response));

    const eventProps = usedCannedResponse
      ? {
          "finally included": true,
          method: usedCannedResponse.method,
        }
      : {
          "finally included": false,
          method: mouse > keyboard ? "mouse" : "keyboard", // consider `keyboard` as dominant method
        };

    trackEngagement("Used canned response", eventPlace, eventProps);
  }

  return shouldTrack;
}
